import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Application components
import { AuthGuard } from '@app/core/guards/auth.guard';
import { ChangePasswordComponent } from '@shared/components/change-password/change-password.component';
import { ConfirmRegistrationComponent } from '@shared/components/confirm-registration/confirm-registration.component';
import { CampaignDetailsComponent } from './components/campaign-details/campaign-details.component';
import { CampaignListComponent } from './components/campaign-list/campaign-list.component';
import { ContactComponent } from './components/contact/contact.component';
import { EditProfileComponent } from './components/edit-profile/edit-profile.component';
import { PrivacyComponent } from './components/privacy/privacy.component';
import { HomeComponent } from './home.component';
import { CookieComponent } from './components/cookie/cookie.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    children: [
      {
        path: '',
        component: CampaignListComponent,
      },
      {
        path: 'campaigns/:lang',
        component: CampaignListComponent,
      },
      {
        path: 'campaigns/:path/:id',
        component: CampaignDetailsComponent,
      },
      {
        path: 'forgotpassword',
        component: ChangePasswordComponent,
      },
      {
        path: 'confirmregistration',
        component: ConfirmRegistrationComponent,
      },
      {
        path: 'edit-profile',
        component: EditProfileComponent,
      },
      {
        path: 'privacy',
        component: PrivacyComponent,
      },
      {
        path: 'cookie',
        component: CookieComponent,
      },
      {
        path: 'contact',
        component: ContactComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomeRoutingModule { }
